import React, { Dispatch, SetStateAction } from 'react';
import { ICBlogPost } from '../../interfaces/ICBlogPost';
import { BlogCards } from './index';
import { PaginationGroup } from '../ui';
import { pageNumberController } from '../../utils';
import { BLOG_INDEX_PAGE_LIMIT } from '../../constants';
import { IBlogReducerStatePaginationData } from '../../interfaces/IBlogReducer';
import { IBlogCategory } from '../../interfaces/IBlogCategory';

interface IBlogPostListProps {
  posts: Array<ICBlogPost>;
  pageNumber: number;
  setPageNumber: Dispatch<SetStateAction<number>>;
  paginationData: IBlogReducerStatePaginationData;
  activeCategory: IBlogCategory;
}

const BlogPostList: React.FC<IBlogPostListProps> = ({
  posts,
  paginationData,
  activeCategory,
  pageNumber,
  setPageNumber,
}) => {
  const isPaginationAvailable = Boolean(
    paginationData[activeCategory.value]?.limit,
  );

  const {
    totalPagesNumber,
    currentPageNumber,
    nextPageNumber,
    prevPageNumber,
  } = pageNumberController({
    isPaginationAvailable,
    limit: BLOG_INDEX_PAGE_LIMIT,
    total: paginationData[activeCategory.value]?.total,
    currentPage: pageNumber,
  });

  return (
    <>
      <BlogCards posts={posts} mb={{ base: '56px', tablet: '88px' }} />
      <PaginationGroup
        prevPageNumber={prevPageNumber}
        setPageNumber={setPageNumber}
        currentPageNumber={currentPageNumber}
        nextPageNumber={nextPageNumber}
        totalPagesNumber={totalPagesNumber}
        mb={400}
      />
    </>
  );
};

export default BlogPostList;
